<template>

            <div @click="goToLink()" :class="{'col-sm-4':!widget.doubleSize,'col-sm-8':widget.doubleSize,'yes-link' : hasLink, 'no-link' : !hasLink}" class="no-widget-padding" >
                <div v-if="(widget.title != null && widget.title.length > 0)" class="section_title_box">
                    <div v-if="widget.title != null && widget.title.length > 0" class="row">
                        <div class="col-sm-12 no-widget-padding">
                            <div class="section_title">
                                <div class="section_title_cont text-center">
                                    <h3>{{widget.title}}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 no-widget-padding">
                            <div class="soproni_small_img_box">
                                <img :src="widget.imageUrl" class="img-responsive" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!(widget.title != null && widget.title.length > 0)" class="coca_cola">
                    <img :src="widget.imageUrl" class="img-responsive" alt="" >
                </div>
            </div>

</template>

<script>
export default{
    props:['widget'],
    computed:{
        hasLink:function () {
            return this.widget.link  && this.widget.link.url && this.widget.link.url.length>0
        }
    },
    methods:{
        goToLink:function () {
            if (!this.hasLink) return;

            if (this.widget.link.external){
                window.open(this.widget.link.url,'_blank');
            }else{
                this.$router.push(this.widget.link.url);
            }
        }
    }
}
</script>

<style scoped>
img{
    width: 100%;
}
.no-link{
    cursor: initial;
}
.yes-link{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// CardWidget.vue?11939b68